module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/feed-alt-1e792617c377fa4b2a31429e1b31a7fc.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/feed-alt.svg
// module id = sVgx
// module chunks = 24